import { PastCallsType } from './calls.service'
import { CallFilters } from './filters/filters.component'

const me = 'me'
const all = 'all'

export const queryKeys = {
  configuration: ['configuration'],

  calls: {
    base: ['calls'],

    admin: {
      all: ['admin', 'calls', 'all'],
      today: ['admin', 'calls', 'today'],
      byDate: (date: string) => ['admin', 'calls', 'date', date],
      byId: (id: number) => ['admin', 'calls', id],
      byUserId: (userId: number) => ['admin', 'calls', 'user', userId],
      byOrganizationId: (organizationId: number) => ['admin', 'calls', 'organization', organizationId],
      debugData: (id: number) => ['admin', 'calls', id, 'debug-data'],
      callsPerDay: (weekOf: string) => ['admin', 'calls', 'calls-per-day', weekOf],
    },

    byId: (id: number) => ['calls', id],
    list: {
      base: ['call-list'],
      upcoming: ['call-list', 'upcoming'],
      ongoing: ['call-list', 'ongoing'],
      past: {
        base: ['call-list', 'past'],
        byType: (type: PastCallsType) => ['call-list', 'past', type],
      },
    },
    accessRequests: {
      base: ['calls', 'access-requests'],
      byId: (id: number) => ['calls', 'access-requests', id],
    },
  },

  users: {
    base: ['users'],
    byId: (id: number) => ['users', id],
    byOrganizationId: (organizationId: number) => ['users', 'organization', organizationId],
    me: ['users', me],
    settings: ['user-settings'],
    search: (query: string) => ['users', 'search', query],
  },

  demoProfiles: {
    base: ['demo-profiles'],
    byId: (id: number) => ['demo-profiles', id],
  },

  intercom: {
    base: ['intercom'],
    admins: ['intercom', 'admins'],
  },

  search: {
    results: {
      byFilters: (filters: CallFilters) => ['search-results', filters],
    },
    attendees: ['search-attendees'],
    speakers: ['search-speakers'],
    guestOrganizations: ['search-guest-organizations'],
  },

  organizations: {
    base: ['organizations'],
    byId: (id: number) => ['organizations', id],
    me: ['organizations', me],
    all: ['organizations', all],
    users: ['organization-users'],
    settings: ['organization-settings'],
  },

  guestOrganizations: {
    base: ['guest-organizations'],
    all: ['all-guest-organizations'],
  },
  callProfiles: {
    base: ['call-profiles'],
    all: ['call-profiles', all],
    byId: (id: number) => ['call-profiles', id],
  },

  templates: {
    base: ['templates'],
    all: ['templates', all],
    byCallId: (callId: number) => ['templates', 'by-call-id', callId],
    byId: (id: number) => ['templates', id],
    models: {
      all: ['templates', 'models'],
      byOrganization: (organizationId: number) => ['templates', 'models', organizationId],
    },
  },

  metrics: {
    completedCalls: ['metrics', 'completed-calls'],
    featureAdoptionByUser: ['metrics', 'feature-adoption-by-user'],
    engagementByUser: ['metrics', 'engagement-by-user'],
    usageByUser: (type: string) => ['metrics', 'usage-by-user', type],
    usageByOrganization: ['metrics', 'usage-by-organization'],
    meetingRoomMetrics: (organizationIds: number[]) => ['metrics', 'meeting-room-metrics', ...organizationIds],
    performance: (organizationId: number | null, startDate: string | null, endDate: string | null) => [
      'metrics',
      'performance',
      organizationId,
      startDate,
      endDate,
    ],
    activity: (organizationId: number | null, startDate: string, endDate: string, precision: string) => [
      'metrics',
      'activity',
      organizationId,
      startDate,
      endDate,
      precision,
    ],
  },
}
